<template>
  <article
    ref="scrollBox"
    class="bus_list_wrap home CompareFlightIndex"
    style="background:#FFFFFF;"
  >
    <section class="pages_content">
      <swiper :swiperImgArray="advertList" :swiperWrapClass="swiperClass"></swiper>

      <div
        class="queryConditions fontSize4"
        style="margin-top:-2rem;padding:0.5rem 0.3rem 0.3rem;box-shadow: 0px 0px 0.3rem 0.01rem #d5d5d5;"
      >
        <div class="flexContainer">
          <div class="flexItem1">
            <div class="inputDiv">
              <!-- <i class="iconfont_new icon-dingwei3 inputIcon"></i> -->
              <div @click="chooseDepCity">目的地：{{ depCity }}</div>
            </div>
          </div>
          <div class="flexItem1">
            <div class="inputDiv">
              <!-- <i class="iconfont_new icon-feiji5 inputIcon"></i> -->
              <div @click="chooseAirCompany">航司：{{ airCompanyName }}</div>
            </div>
          </div>
        </div>
        <div class="flexContainer">
          <div class="flexItem1">
            <div class="inputDiv">
              <!-- <i class="iconfont_new icon-rili inputIcon"></i> -->
              <div @click="chooseDepDate">
                日期：{{ depDate }}
                <span v-if="depDate == today" class="colorprimary">今天</span>
                <span v-if="depDate == tomorrow" class="colorprimary">明天</span>
              </div>
            </div>
          </div>
          <div class="flexItem1">
            <div class="inputDiv">
              <!-- <i class="iconfont_new icon-feiji5 inputIcon"></i> -->
              <div @click="chooseGoOrBack">行程类型：{{ isDep == 1 ? '去程' : '返程' }}</div>
            </div>
          </div>
        </div>
        <div class="flexContainer">
          <div class="flexItem1" style="margin-top:0.3rem;">
            <div class="queryConditionsButton textalignM" @click="getFlightList">查询飞机票</div>
          </div>
        </div>
      </div>

      <div class="aTableResult">
        <div class="flexContainer">
          <div class="textalignM flexItem1">
            <div class="resultTitle fontSize4">广州机场</div>
            <div class="flexContainer resultSubTitle">
              <div class="flexItem1 textalignM fontSize38">时间</div>
              <div class="flexItem1 textalignM fontSize38">价格</div>
            </div>

            <Spin v-if="gzFlightListLoading">
              <Icon type="ios-loading" size="18" class="colorprimary demo-spin-icon-load"></Icon>
              <div class="colorprimary">加载中</div>
            </Spin>

            <div class="noRecord" v-if="gzFlightList.length == 0 && !gzFlightListLoading">无航班记录</div>
            <div class="cityBox" v-else>
              <div
                class="flexContainer" style="position:relative;"
                v-for="data in gzFlightList"
                :key="data.id"
                @click="goFlightDetail(data)"
              >
                <div class="songchepiao" v-if="data.airCompanyName == '中国国航'">送车票</div>
                <div
                  class="flexItem1 textalignM tableTime tableTimeTd tableTimeGZ tableTimeGZTd"
                >{{ data.depTime }}</div>
                <div class="flexItem1 textalignM tablePrice tableTimeGZ tableTimeGZTd2">
                  <span class="priceIcon">¥</span>
                  {{ data.fakePrice }}
                </div>
              </div>
            </div>
          </div>
          <div class="textalignM flexItem1">
            <div class="resultTitle fontSize4">深圳机场</div>
            <div class="flexContainer resultSubTitle">
              <div class="flexItem1 textalignM fontSize38">时间</div>
              <div class="flexItem1 textalignM fontSize38">价格</div>
            </div>

            <Spin v-if="szFlightListLoading">
              <Icon type="ios-loading" size="18" class="colorprimary demo-spin-icon-load"></Icon>
              <div class="colorprimary">加载中</div>
            </Spin>

            <div class="noRecord" v-if="szFlightList.length == 0 && !szFlightListLoading">无航班记录</div>
            <div class="cityBox" v-else>
              <div
                class="flexContainer"
                v-for="data in szFlightList"
                :key="data.id"
                @click="goFlightDetail(data)"
              >
                <div
                  class="flexItem1 textalignM tableTime tableTimeTd tableTimeSZ tableTimeSZTd"
                >{{ data.depTime }}</div>
                <div class="flexItem1 textalignM tablePrice tableTimeSZ tableTimeSZTd2">
                  <span class="priceIcon">¥</span>
                  {{ data.fakePrice}}
                </div>
              </div>
            </div>
          </div>
          <div class="textalignM flexItem1">
            <div class="resultTitle fontSize4">珠海机场</div>
            <div class="flexContainer resultSubTitle">
              <div class="flexItem1 textalignM fontSize38">时间</div>
              <div class="flexItem1 textalignM fontSize38">价格</div>
            </div>

            <Spin v-if="zhFlightListLoading">
              <Icon type="ios-loading" size="18" class="colorprimary demo-spin-icon-load"></Icon>
              <div class="colorprimary">加载中</div>
            </Spin>
            <div class="noRecord" v-if="zhFlightList.length == 0 && !zhFlightListLoading">无航班记录</div>
            <div class="cityBox" v-else>
              <div
                class="flexContainer" style="position:relative;"
                v-for="data in zhFlightList"
                :key="data.id"
                @click="goFlightDetail(data)"
              >
                <div class="songchepiao" v-if="data.depCityName == '珠海' && data.arrAirportName =='大兴机场' && data.airCompanyName == '南方航空'">送车票</div>
                <div
                  class="flexItem1 textalignM tableTime tableTimeTd tableTimeZH tableTimeZHTd"
                >{{ data.depTime }}</div>
                <div class="flexItem1 textalignM tablePrice tableTimeZH tableTimeZHTd2">
                  <span class="priceIcon">¥</span>
                  {{ data.fakePrice }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import Swiper from "./child-components/Swiper";
import scopeApi from "../request/scopeApi";
import flightApi from "../request/flightApi";
import { mapState } from "vuex";
import baseTool from "../utils/baseFunction";
export default {
  name: "CompareFlightIndex",
  data() {
    return {
      name: "", // 商户标识

      advertList: [],
      swiperClass: "big_banner_wrap",

      today: baseTool.formatterDate(new Date()),//今天
      tomorrow:  baseTool.formatterDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)),//明天

      //航司：
      airCompany: "",
      airCompanyArray: [
        { name: "全部", code: "" },
        { name: "南方航空", code: "CZ" },
        { name: "中国国航", code: "CA" },
        { name: "深圳航空", code: "ZH" },
        { name: "中国东方航空公司", code: "MU" },
      ], //航空公司列表

      //往返：
      goBackIndex: "true",
      goBackArray: [
        { text: "去程", value: true },
        { text: "返程", value: false },
      ],

      gzFlightList: [],
      szFlightList: [],
      zhFlightList: [],

      gzFlightListLoading: false,
      szFlightListLoading: false,
      zhFlightListLoading: false,
    };
  },
  components: {
    swiper: Swiper,
  },
  activated() {
    this.getFlightList();

    this.setStoreData({
      selectedFlightList: [],
      selectedPolicyList: [],
      ifBackRefresh: true,
    }); // 每次进入此页都清空上次选择的航班与政策。
  },
  mounted() {
    this.getAdvertList();
  },
  computed: mapState({
    isDep: (state) => state.flight.isDep,
    airLineCode: (state) => state.flight.airLineCode,
    depDate: (state) => state.flight.depDate,
    backDate: (state) => state.flight.backDate,
    depCity: (state) => state.flight.depCity,
    depCityPortCode: (state) => state.flight.depCityPortCode,
    arrCity: (state) => state.flight.arrCity,
    arrCityPortCode: (state) => state.flight.arrCityPortCode,
    airCompanyCode: (state) => state.flight.airCompanyCode,
    airCompanyName: (state) => state.flight.airCompanyName,
    flightType: (state) => state.flight.flightType,
    psgType: (state) => state.flight.psgType,
    cabinRank: (state) => state.flight.cabinRank,
    directFlight: (state) => state.flight.directFlight,
    selectedFlightList: (state) => state.flight.selectedFlightList,
    selectedPolicyList: (state) => state.flight.selectedPolicyList,
    OpenId: (state) => state.user.OpenId,

    gzCityPortCode: (state) => state.flight.gzCityPortCode,
    szCityPortCode: (state) => state.flight.szCityPortCode,
    zhCityPortCode: (state) => state.flight.zhCityPortCode,
  }),
  methods: {
    setStoreData(updateObj) {
      this.$store.commit("flight/setFlightQueryCondition", updateObj);
    },
    chooseDepCity() {
      this.$router.push({
        name: "City",
        params: {
          mode: "dep",
        },
      });
    },
    chooseAirCompany() {
      let that = this;
      let tmpArray = new Array();
      for (let i = 0; i < this.airCompanyArray.length; i++) {
        let tmp = {
          label: this.airCompanyArray[i].name,
          value: this.airCompanyArray[i].code,
        };
        tmpArray.push(tmp);
      }
      this.$weui.picker(tmpArray, {
        onConfirm(result) {
          that.setStoreData({
            airCompanyName: result[0].label,
            airCompanyCode: result[0].value,
          });
        },
      });
    },
    chooseDepDate() {
      let that = this;
      this.$weui.datePicker({
        start: new Date(), // 从今天开始
        end: baseTool.addDate(new Date(), 60),
        onConfirm: (result) => {
          let tmpDate =
            result[0].value +
            "-" +
            (result[1].value < 10 ? "0" + result[1].value : result[1].value) +
            "-" +
            (result[2].value < 10 ? "0" + result[2].value : result[2].value);
          console.log(tmpDate);
          that.setStoreData({
            depDate: tmpDate,
          });
        },
      });
    },
    chooseGoOrBack() {
      let that = this;
      let tmpArray = new Array();
      for (let i = 0; i < this.goBackArray.length; i++) {
        let tmp = {
          label: this.goBackArray[i].text,
          value: this.goBackArray[i].value,
        };
        tmpArray.push(tmp);
      }
      this.$weui.picker(tmpArray, {
        onConfirm(result) {
          that.setStoreData({
            isDep: result[0].value,
          });
        },
      });
    },

    //获取轮播图列表：
    getAdvertList() {
      let that = this;
      this.advertList = [];
      scopeApi.getAdvertInfoList(2).then((sucRes) => {
        if (sucRes.success) {
          for (let i = 0; i < sucRes.data.length; i++) {
            that.advertList.push(sucRes.data[i].GoodsLogoUrl);
          }
        }
      });
      this.advertList.push(
        "http://www.callmefix.net/api/Event/getImage?type=3&name=38"
      );
    },

    goFlightDetail(data) {
      let that = this;
      let selectedFlightList = [...this.selectedFlightList];
      selectedFlightList.push(data);

      this.$store.commit("flight/setFlightQueryCondition", {
        selectedFlightList: selectedFlightList,
      });
      this.$router.push({
        name: "FlightNoDetail",
        params: { name: that.name },
      });
    },

    //确定：
    getFlightList() {
      this.gzRequest();
      this.szRequest();
      this.zhRequest();
    },

    gzRequest() {
      this.gzFlightList = [];
      this.gzFlightListLoading = true;
      flightApi
        .getFlightList(
          this.flightType,
          this.cabinRank,
          this.psgType,
          this.isDep ? this.gzCityPortCode : this.arrCityPortCode,
          this.isDep ? this.arrCityPortCode : this.gzCityPortCode,
          this.depDate,
          this.airCompanyCode
        )
        .then((sucRes) => {
          this.gzFlightListLoading = false;
          let result = sucRes;
          if (result.success && result.data.length > 0) {
            sucRes.data.forEach((obj) => {
              let isEventFlight = false;
              if (obj.airCompanyName == "中国国航" && this.isDep) {
                isEventFlight = true;
              }

              let depInfoTime = obj.depDate + " " + obj.depTime;
              let nowTime = baseTool.dateFormat(new Date(), "yyyy-MM-dd HH:mm");
              if (nowTime > depInfoTime) {
                // 过滤早于当前时间的航班，主要是当天。
                obj.isTimeOut = true;
              } else {
                obj.isTimeOut = false;
              }
              obj.fakePrice =
                obj.policys[0] && obj.policys[0].priceDatas[0]
                  ? obj.policys[0].priceDatas[0].price
                  : " - ";
              obj.isShowList = false; // 是否展开政策、仓位
              obj.policys.forEach((pol) => {
                pol.isFreeBusTicket = isEventFlight;

                pol.isSelected = false; // 选中政策，默认没选
                pol.chaRule = null; // 改签规则，默认空，要先请求后保存。
                pol.refRule = null; // 退票规则，默认空，要先请求后保存。
              });
            });
            this.gzFlightList = sucRes.data;
          } else {
          }
        });
    },
    szRequest() {
      this.szFlightList = [];
      this.szFlightListLoading = true;
      flightApi
        .getFlightList(
          this.flightType,
          this.cabinRank,
          this.psgType,
          this.isDep ? this.szCityPortCode : this.arrCityPortCode,
          this.isDep ? this.arrCityPortCode : this.szCityPortCode,
          this.depDate,
          this.airCompanyCode
        )
        .then((sucRes) => {
          this.szFlightListLoading = false;
          let result = sucRes;
          if (sucRes.success) {
            sucRes.data.forEach((obj) => {
              let depInfoTime = obj.depDate + " " + obj.depTime;
              let nowTime = baseTool.dateFormat(new Date(), "yyyy-MM-dd HH:mm");
              if (nowTime > depInfoTime) {
                // 过滤早于当前时间的航班，主要是当天。
                obj.isTimeOut = true;
              } else {
                obj.isTimeOut = false;
              }
              obj.isShowList = false; // 是否展开政策、仓位
              obj.fakePrice =
                obj.policys[0] && obj.policys[0].priceDatas[0]
                  ? obj.policys[0].priceDatas[0].price
                  : " - ";
              obj.policys.forEach((pol) => {
                pol.isSelected = false; // 选中政策，默认没选
                pol.chaRule = null; // 改签规则，默认空，要先请求后保存。
                pol.refRule = null; // 退票规则，默认空，要先请求后保存。
              });
            });
            this.szFlightList = sucRes.data;
          } else {
          }
        });
    },
    zhRequest() {
      this.zhFlightList = [];
      this.zhFlightListLoading = true;
      flightApi
        .getFlightList(
          this.flightType,
          this.cabinRank,
          this.psgType,
          this.isDep ? this.zhCityPortCode : this.arrCityPortCode,
          this.isDep ? this.arrCityPortCode : this.zhCityPortCode,
          this.depDate,
          this.airCompanyCode
        )
        .then((sucRes) => {
          this.zhFlightListLoading = false;
          let result = sucRes;
          if (sucRes.success) {
            sucRes.data.forEach((obj) => {
              let isEventFlight = false;
              if (
                obj.airCompanyName == "南方航空" &&
                this.isDep &&
                obj.arrAirportCode == "PKX"
              ) {
                isEventFlight = true;
              }

              let depInfoTime = obj.depDate + " " + obj.depTime;
              let nowTime = baseTool.dateFormat(new Date(), "yyyy-MM-dd HH:mm");
              if (nowTime > depInfoTime) {
                // 过滤早于当前时间的航班，主要是当天。
                obj.isTimeOut = true;
              } else {
                obj.isTimeOut = false;
              }
              obj.isShowList = false; // 是否展开政策、仓位

              obj.fakePrice =
                obj.policys[0] && obj.policys[0].priceDatas[0]
                  ? obj.policys[0].priceDatas[0].price
                  : " - ";
              obj.policys.forEach((pol) => {
                let cabinCode = pol.cabin[0].cabinCode;
                if (isEventFlight && "KUALQEVZTNR".indexOf(cabinCode) != -1) {
                  pol.isFreeBusTicket = isEventFlight;
                }

                pol.isSelected = false; // 选中政策，默认没选
                pol.chaRule = null; // 改签规则，默认空，要先请求后保存。
                pol.refRule = null; // 退票规则，默认空，要先请求后保存。
              });
            });
            this.zhFlightList = sucRes.data;
          } else {
          }
        });
    },
  },
};
</script>

<style scoped lang="less">
@import "../style/home.less";
</style>



// WEBPACK FOOTER //
// src/components/CompareFlightIndex.vue